import Tippy from '@tippyjs/react'
import React from 'react'

interface props{
    children: React.ReactElement | undefined
    , tip: string
}

const Tooltip = ({children, tip}: props) => {
    return (
        <>
        <Tippy content={tip}
            placement=  {"left"}
            //inertia: true,
            // flipBehavior =  {["top", "right"]}
            theme =  {"light"}
            arrow =  {true}
        >
            {children}
        </Tippy>
        </>
    )
}

export default Tooltip
